import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const UserDataIcon = ({
  width = "24",
  height = "24",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 16.6154C19 14.1088 14.3275 12.8462 12 12.8462C9.6725 12.8462 5 14.1088 5 16.6154V18.5H19V16.6154Z"
          fill="url(#paint0_linear_13551_1732)"
        />
        <path
          d="M15.5 8.26923C15.5 10.3612 13.9425 12.0385 12 12.0385C11.0717 12.0385 10.1815 11.6413 9.52513 10.9345C8.86875 10.2276 8.5 9.26889 8.5 8.26923C8.5 7.26957 8.86875 6.31085 9.52513 5.60398C10.1815 4.89711 11.0717 4.5 12 4.5C13.9425 4.5 15.5 6.17731 15.5 8.26923Z"
          fill="url(#paint1_linear_13551_1732)"
        />
        <linearGradient
          id="paint0_linear_13551_1732"
          x1="5"
          y1="16.231"
          x2="18.5"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1C3D70" />
          <stop offset="0.5" stopColor="#0861A8" />
          <stop offset="1" stopColor="#2193D0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13551_1732"
          x1="5"
          y1="16.231"
          x2="18.5"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1C3D70" />
          <stop offset="0.5" stopColor="#0861A8" />
          <stop offset="1" stopColor="#2193D0" />
        </linearGradient>
      </svg>
    </IconWrapper>
  );
};
